<template>
  <div class="login-page">
    <h1 class="mb-15">Login Smarthand</h1>

    <!-- Login In Form -->
    <a-form
      :form="form"
      class="login-form"
      @submit="handleSubmit"
      :hideRequiredMark="true"
    >
      <a-form-item class="mb-5" label="Username" :colon="false">
        <a-input
          v-decorator="[
            'username',
            {
              rules: [{ required: true, message: 'Please input Username!' }],
            },
          ]"
          placeholder="Username"
        />
      </a-form-item>
      <a-form-item class="mb-5" label="Password" :colon="false">
        <a-input
          v-decorator="[
            'password',
            {
              rules: [{ required: true, message: 'Please input password!' }],
            },
          ]"
          type="password"
          placeholder="Password"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          block
          html-type="submit"
          :loading="callingAPI"
          class="login-form-button"
        >
          LOGIN
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import {login, updateLoginInfo} from '@/services/landing-page/auth'
  export default {
    name: 'LoginPage',
    data() {
      return {
        callingAPI: false
      }
    },
    beforeCreate() {
			this.form = this.$form.createForm(this, { name: 'LoginForm'});
		},
    methods: {
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields(async (err, form) => {
          if (!err) {
            try {
              this.callingAPI = true
              const data = {
                user_name: form.username,
                password: form.password
              }

              const response = await login(data)
              this.callingAPI = false
              if (response.status === 0) {
                this.$notification.error({
                  message: 'Thất bại',
                  description: response.message,
                });
              } else {
                const loginInfo = {
                  access_token: response.access_token,
                  data: response.data,
                  status: response.status,
                  token_type: response.token_type,
                };
                updateLoginInfo(loginInfo);
                this.$router.push({ path: "/" });
              }    
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .login-form {
    width: 500px;
  }
}
</style>